export default {
  id: 134,
  title: 'Target #134 - Wig',
  url: 'https://cssbattle.dev/play/134',
  colors: ['#62306D', '#F7EC7D'],
  solution:
    '<p a><p b><style>body{background:#62306d}p{position:fixed;top:54;width:80;height:160;background:#f7ec7d;border-radius:80px 0 40px}[a]{left:120}[b]{left:200;transform:scalex(-1)}</style>',
}
